(function() {
    let infowindow, map, markers, markersRemaining, geocoder, bounds;

    const PRNemovitostiMaps = {
        items: {},
        options_default: {
            id: 'gmap',
            //center: new google.maps.LatLng(49.81, 15.46),
            zoom: 7,
            minZoom: 1,
            maxZoom: 18,
            bounds_zoom: null,
            autozoom: true,
            markercluster_maxzoom: 13,
            url_ajax: null,
            url_icon: null,
        },
        initialize: function(items, opts) {
            PRNemovitostiMaps.options = {...PRNemovitostiMaps.options_default, ...opts};
            PRNemovitostiMaps.items = items;

            const mapEl = document.querySelector('#'+PRNemovitostiMaps.options.id),
                mapOpts = {
                    'zoom': PRNemovitostiMaps.options.zoom,
                    'maxZoom': PRNemovitostiMaps.options.maxZoom,
                    'minZoom': PRNemovitostiMaps.options.minZoom,
                    'center': PRNemovitostiMaps.options.center,
                    'mapTypeId': google.maps.MapTypeId.ROADMAP
                };

            infowindow = new google.maps.InfoWindow();
            map = new google.maps.Map(mapEl, mapOpts);
            markers = [];
            markersRemaining = PRNemovitostiMaps.items.length;
            geocoder = new google.maps.Geocoder();
            bounds = new window.google.maps.LatLngBounds();

            mapEl.dataStorage = {
                map: map,
                markers: markers,
                bounds: bounds
            };

            if (typeof window.maps_colors != 'undefined')
                map.set('styles', window.maps_colors);

            if (typeof window.maps_marker_icon_anchor != 'undefined') {
                if (typeof window.maps_marker_icon != 'undefined')
                    window.maps_marker_icon.anchor = new google.maps.Point(window.maps_marker_icon_anchor[0], window.maps_marker_icon_anchor[1]);

                if (typeof window.maps_marker_icon_hover != 'undefined')
                    window.maps_marker_icon_hover.anchor = new google.maps.Point(window.maps_marker_icon_anchor[0], window.maps_marker_icon_anchor[1]);
            }
        },
        onAllMarkersLoaded: function () {
            let markerCluster = new MarkerClusterer(map, markers, {maxZoom: PRNemovitostiMaps.options.markercluster_maxzoom});
            markerCluster.setCalculator(function(markers, numStyles) {
                let count = 0;
                for (var i in markers) {
                    if (typeof markers[i].count !== 'undefined') {
                        count = count + markers[i].count
                    } else {
                        count = count + 1;
                    }
                }
                return {
                    text: count,
                    index: count
                }
            });
        },
        saveLocation: function (item, loc_w, loc_l) {
            if (!PRNemovitostiMaps.options.url_ajax)
                return;

            let data = {};
            if (typeof item.id_zs != 'undefined')
                data['id_zs'] = item.id_zs;
            if (typeof item.id_uzivatel != 'undefined')
                data['id_uzivatel'] = item.id_uzivatel;

            data['adresa'] = item.adresa;
            data['loc_w'] = loc_w;
            data['loc_l'] = loc_l;
            data['status'] = 'ok';

            let request = new XMLHttpRequest();
            request.open('GET', PRNemovitostiMaps.options.url_ajax + '?' + dataToQueryString(data), true);
            request.send();
        },
        addMarkerByAddress: function (item) {
            geocoder.geocode({address: item.adresa}, function(results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    var marker = new google.maps.Marker({position: results[0].geometry.location, count: item.pocet, icon: PRNemovitostiMaps.images(item)});
                    markers.push(marker);
                    PRNemovitostiMaps.setBublinkaListener(item, marker);
                    PRNemovitostiMaps.saveLocation(item, results[0].geometry.location.lat(), results[0].geometry.location.lng());

                    let latLng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                    bounds.extend(latLng);
                    // pokud zjistujeme adresu tak ce ceka na pozadavek do google, takze musime pak znovu vycentrovat protoze centrovani probehne drive nez prijde odpoved
                    PRNemovitostiMaps.center(map, bounds);

                    if (typeof item.add_marker_lisener != 'undefined' && item.add_marker_lisener)
                        window[item.add_marker_lisener](map, item, marker);
                } else {
                    if (window.console && window.console.log)
                        window.console.log("nenalezena pozice pro nemovitost: " + status + " " + item.adresa);

                    if (status === 'ZERO_RESULTS') {
                        const data = {
                            'id_zs': item.id_zs,
                            'loc_l': 0,
                            'loc_w': 0,
                            'status': 'error'
                        };

                        let request = new XMLHttpRequest();
                        request.open('GET', PRNemovitostiMaps.options.url_ajax + '?' + dataToQueryString(data), true);
                        request.send();
                    }
                }

                markersRemaining--;
                if (markersRemaining === 0)
                    PRNemovitostiMaps.onAllMarkersLoaded();
            });
        },
        addMarkerByLocation: function (item) {
            if (item.loc_w && item.loc_l && parseFloat(item.loc_w) === 0 && parseFloat(item.loc_l) === 0) {
                markersRemaining--;
                if (markersRemaining === 0) PRNemovitostiMaps.onAllMarkersLoaded();
                return;
            }
            let latLng = new google.maps.LatLng(item.loc_w, item.loc_l);
            bounds.extend(latLng);

            let marker = new google.maps.Marker({'position': latLng,  count: item.pocet, icon: PRNemovitostiMaps.images(item)});
            markers.push(marker);
            PRNemovitostiMaps.setBublinkaListener(item, marker);

            if (typeof item.add_marker_lisener != 'undefined' && item.add_marker_lisener)
                window[item.add_marker_lisener](map, item, marker);

            markersRemaining--;
            if (markersRemaining === 0)
                PRNemovitostiMaps.onAllMarkersLoaded();
        },
        images: function (item) {
            if (typeof window.maps_marker_icon != 'undefined')
                return window.maps_marker_icon;

            if (item.icon)
                return item.icon;

            if (!PRNemovitostiMaps.options.url_icon)
                return null;

            let images = 'dum_1.png';
            if (item.pocet >= 2 && item.pocet <= 5)
                images = 'dum_'+item.pocet+'.png';
            else if (item.pocet > 5)
                images = 'dum_5plus.png';

            return {
                url: PRNemovitostiMaps.options.url_icon + images,
            };
        },
        setHoverImages: function(item, marker) {
            if (typeof window.maps_marker_icon_hover == 'undefined')
                return;

            for (let i in markers)
                markers[i].setIcon(PRNemovitostiMaps.images(item));

            marker.setIcon(window.maps_marker_icon_hover);
        },
        setBublinkaListener: function (item, marker) {

            if (typeof item.bublinka == 'undefined')
                return;

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.setContent(item.bublinka);
                infowindow.open(map, marker);

                PRNemovitostiMaps.setHoverImages(item, marker);
            });
            if (typeof item.bublinka_open != 'undefined' && item.bublinka_open) {
                infowindow.setContent(item.bublinka);
                infowindow.open(map,marker);
                PRNemovitostiMaps.setHoverImages(item, marker);
            }
        },
        run: function () {
            var markerAdded = false;
            for (var i = 0; i < PRNemovitostiMaps.items.length; i++) {
                var item = PRNemovitostiMaps.items[i];
                if (item.loc_l && item.loc_w) {
                    PRNemovitostiMaps.addMarkerByLocation(item);
                    markerAdded = true;
                } else if (!item.loc_l && !item.loc_w && parseFloat(item.loc_l) !== 0 && parseFloat(item.loc_w) !== 0) {
                    PRNemovitostiMaps.addMarkerByAddress(item);
                    markerAdded = true;
                } else {
                    markersRemaining--;
                    if (markersRemaining === 0) {
                        PRNemovitostiMaps.onAllMarkersLoaded();
                    }
                }
            }

            if (markerAdded) { // nepridal jsem zadnu marker, neni urceno jak se ma mapa posunout, tak ji zamerime na CR (a SK).
                PRNemovitostiMaps.center(map, bounds);
            } else {
                map.setOptions({center:  new google.maps.LatLng(50.0, 16.0)}); // ceska republika
            }
        },
        center: function(map, bounds) {
            if (PRNemovitostiMaps.options.autozoom && !bounds.isEmpty()) {
                map.fitBounds(bounds);
            }

            if (PRNemovitostiMaps.options.bounds_zoom)
                map.setOptions({maxZoom: PRNemovitostiMaps.options.bounds_zoom});
        }
    };
    window.PRNemovitostiMaps = PRNemovitostiMaps;
}());